import { Backdrop, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.weesu.dark_blue,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    webkitBackdropFilter: "blur(1px)",
    backdropFilter: "blur(1px)",
    height: "100vh",
    width: "100%",
  },
  notBackdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.weesu.dark_blue,
    backdropFilter: "none",
    webkitBackdropFilter: "none",
  },
}));

const Loading = ({ loading, style = {}, notBackdrop = false }) => {
  const classes = useStyles();

  return (
    <Backdrop
      sx={{ ...style }}
      className={notBackdrop ? classes.notBackdrop : classes.backdrop}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loading;
